import { ListButton } from "react-admin";
import BackIcon from "@material-ui/icons/ArrowBack";

function BackButton() {
  return <ListButton label="back" icon={<BackIcon />} />;
}
export default BackButton;
